import { IDs } from '../../../helpers/IDs';
import { getCO2AequivalentSubscope2 } from '../getCO2Aequivalent';
import { makeSimpleKennzahl } from '../strukturiert/makeKennzahl';
import { Kennzahl } from '../strukturiert/Kennzahl';

export function processSubscope2(row: any, data: any, item: any, jahr: number) {
    row = {...row};
    // console.log('SS2 - IN: ', jahr, row);
    // Konfig
    const konfData: Array<any> = data[IDs.ENT_KONFIGURATION] || [];
    const co2_fussabdruck_ghg = konfData.length > 0 && konfData[0].co2_fussabdruck_modus === 'ghg';
    const modus = row.modus;

    // Wir müssen uns erst den Namen des Materials holen
    const arr_mat = data[IDs.ENT_CO2_SCOPE3_FAKTOREN_GUETER];
    const mat = arr_mat.find((m: any) => (row.art_tid_orig || row.art_tid) === m.tid);
    if (!mat && modus && modus !== 'supplier_specific' && modus !== 'user_specific') {
        // console.log('SS2 - NO MAT', row, arr_mat);
        return;
    }
    // Faktor bestimmen
    let faktor_wert = 0;
    let faktor_name = '';
    let faktor_quelle = '';
    let faktor_multiplier = 1000;
    let faktor_datenqualiaet = '';
    let einheit = 't';
    let einheit_user = row.einheit || 'kg';
    if (!modus || !co2_fussabdruck_ghg || modus === 'supplier_specific' || modus === 'user_specific') {
        faktor_wert = row.faktor;
        faktor_quelle = `Eingabe durch Nutzer:in${row.quelle ? ` / Quelle: ${row.quelle}` : ''}`;
        faktor_name = row.name ? row.name : row.art_tid;
        einheit = row.einheit;
        einheit_user = row.einheit;
        faktor_multiplier = 1000;
    } else {
        if (modus === 'average_data') {
            if ( einheit_user === 'stk') {
                einheit = 'stk';
                faktor_multiplier = 1;
            } else
            if ( einheit_user === 't') {
                einheit = 't';
                faktor_multiplier = 1;
            } else
            if ( einheit_user === 'kg') {
                einheit = 't';
                faktor_multiplier = 1000;
            }
        } else
        if (modus === 'spend_based') {
            einheit = 'euro';
            einheit_user = '€';
            faktor_multiplier = 1;

        }
        const faktor = getCO2AequivalentSubscope2(data, jahr, mat.name, einheit);
        // console.log('S2', faktor, einheit, mat.name);
        faktor_wert = faktor.wert;
        faktor_name = faktor.name;
        faktor_quelle = faktor.quelle;
        faktor_datenqualiaet = faktor.datenqualitaet;
    }

    const value = faktor_wert * (row.menge / faktor_multiplier);
    const key_wert = 'co2_fussabdruck_s3_ss2_wert';
    const key_items = 'co2_fussabdruck_s3_ss2_items';
    if (!item[key_items]) {
        item[key_items] = [];
    }
    if (faktor_name === 'Dienstleistungen') {
        return;
    }
    // console.log('SS2 - PROC: ', jahr, value, faktor_name, faktor_wert, row);
    row.value = value;
    row.name = faktor_name;
    row.faktor = faktor_wert * (1000000 / faktor_multiplier);
    row.einheit = einheit_user;
    row.quelle = faktor_quelle;
    row.faktor_einheit = 'gCO₂Äq/' + einheit_user;
    row.datenqualitaet_emissionsfaktor = ['supplier_specific', 'user_specific'].indexOf(modus) !== -1
        ? row.datenqualitaet_emissionsfaktor
        : faktor_datenqualiaet;
    item[key_items].push(row);
    item[key_wert] = (item[key_wert] || 0) + value;
    // console.log('SS2 - IN: ', jahr, value, item.co2_fussabdruck_scope3, item.co2_fussabdruck_total);
    if (!isNaN(value)) {
        item.co2_fussabdruck_scope3 = (item.co2_fussabdruck_scope3 || 0) + value;
        item.co2_fussabdruck_total = (item.co2_fussabdruck_total || 0) + value;
    }
    // console.log('SS2 - OUT: ', jahr, value, item.co2_fussabdruck_scope3, item.co2_fussabdruck_total);
    // Kennzahl erstellen
    makeSimpleKennzahl(Kennzahl.BEREICH_SCOPE3, 'ss2_' + row.tid, jahr, row.standort_tid_orig, row.tid,
                        'Menge' , row.name, row.menge, row.value, row.einheit,
                        row.faktor, faktor_quelle, data, row.faktor_einheit);
}
